function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m240 341.480469v-13.480469c0-57.34375-46.65625-104-104-104s-104 46.65625-104 104v13.480469c-18.886719 9.007812-32 28.238281-32 50.519531 0 30.878906 25.128906 56 56 56 4.425781 0 8-3.585938 8-8v-96c0-4.414062-3.574219-8-8-8-2.71875 0-5.375.265625-8 .640625v-8.640625c0-48.519531 39.480469-88 88-88s88 39.480469 88 88v8.640625c-2.625-.375-5.28125-.640625-8-.640625-4.425781 0-8 3.585938-8 8v96c0 4.414062 3.574219 8 8 8 2.257812 0 4.472656-.175781 6.664062-.433594-3.191406 9.511719-12.089843 16.433594-22.664062 16.433594h-41.472656c-3.3125-9.289062-12.113282-16-22.527344-16-13.230469 0-24 10.769531-24 24s10.769531 24 24 24c10.414062 0 19.214844-6.710938 22.527344-16h41.472656c21.144531 0 38.335938-16.550781 39.734375-37.351562 19.027344-8.953126 32.265625-28.265626 32.265625-50.648438 0-22.28125-13.113281-41.511719-32-50.519531zm-192 89.710937c-18.230469-3.710937-32-19.871094-32-39.191406s13.769531-35.480469 32-39.191406zm88 48.808594c-4.414062 0-8-3.59375-8-8s3.585938-8 8-8 8 3.59375 8 8-3.585938 8-8 8zm88-48.808594v-78.390625c18.230469 3.710938 32 19.878907 32 39.191407s-13.769531 35.488281-32 39.199218zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m472 0h-224c-13.230469 0-24 10.769531-24 24v192c0 13.230469 10.769531 24 24 24h80v40c0 3.230469 1.945312 6.152344 4.9375 7.390625.992188.410156 2.03125.609375 3.0625.609375 2.078125 0 4.128906-.816406 5.65625-2.34375l45.65625-45.65625h84.6875c13.230469 0 24-10.769531 24-24v-192c0-13.230469-10.769531-24-24-24zm8 216c0 4.40625-3.585938 8-8 8h-88c-2.128906 0-4.160156.839844-5.65625 2.34375l-34.34375 34.34375v-28.6875c0-4.414062-3.574219-8-8-8h-88c-4.414062 0-8-3.59375-8-8v-192c0-4.40625 3.585938-8 8-8h224c4.414062 0 8 3.59375 8 8zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m440 96h-12.167969c-.726562-2.0625-1.542969-4.089844-2.449219-6.0625l12.273438-12.28125c3.128906-3.128906 3.128906-8.183594 0-11.3125l-24-24c-3-3-8.3125-3-11.3125 0l-12.28125 12.28125c-1.964844-.90625-3.992188-1.722656-6.0625-2.449219v-12.175781c0-4.414062-3.574219-8-8-8h-32c-4.425781 0-8 3.585938-8 8v12.175781c-2.070312.726563-4.097656 1.542969-6.0625 2.449219l-12.28125-12.28125c-1.496094-1.503906-3.527344-2.34375-5.65625-2.34375s-4.160156.839844-5.65625 2.34375l-24 24c-3.128906 3.128906-3.128906 8.183594 0 11.3125l12.273438 12.28125c-.898438 1.972656-1.722657 4-2.449219 6.0625h-12.167969c-4.425781 0-8 3.585938-8 8v32c0 4.414062 3.574219 8 8 8h12.167969c.726562 2.0625 1.542969 4.089844 2.449219 6.0625l-12.273438 12.28125c-3.128906 3.128906-3.128906 8.183594 0 11.3125l24 24c3 3 8.3125 3 11.3125 0l12.28125-12.28125c1.964844.90625 3.992188 1.722656 6.0625 2.449219v12.175781c0 4.414062 3.574219 8 8 8h32c4.425781 0 8-3.585938 8-8v-12.175781c2.070312-.726563 4.097656-1.542969 6.0625-2.449219l12.28125 12.28125c1.496094 1.503906 3.527344 2.34375 5.65625 2.34375s4.160156-.839844 5.65625-2.34375l24-24c3.128906-3.128906 3.128906-8.183594 0-11.3125l-12.273438-12.28125c.898438-1.972656 1.722657-4 2.449219-6.0625h12.167969c4.425781 0 8-3.585938 8-8v-32c0-4.414062-3.574219-8-8-8zm-8 32h-10.097656c-3.644532 0-6.832032 2.464844-7.742188 6-1.257812 4.847656-3.113281 9.441406-5.503906 13.648438-1.785156 3.136718-1.25 7.070312 1.296875 9.617187l10.734375 10.734375-12.6875 12.6875-10.734375-10.734375c-2.554687-2.554687-6.503906-3.082031-9.617187-1.296875-4.207032 2.398438-8.800782 4.246094-13.648438 5.503906-3.527344.902344-6 4.097656-6 7.742188v10.097656h-16v-10.097656c0-3.644532-2.472656-6.832032-6-7.742188-4.847656-1.25-9.441406-3.105468-13.648438-5.503906-3.121093-1.792969-7.070312-1.265625-9.617187 1.296875l-10.734375 10.734375-12.6875-12.6875 10.734375-10.734375c2.546875-2.546875 3.082031-6.488281 1.296875-9.617187-2.398438-4.207032-4.246094-8.800782-5.503906-13.648438-.917969-3.535156-4.097656-6-7.742188-6h-10.097656v-16h10.097656c3.644532 0 6.832032-2.464844 7.742188-6 1.257812-4.847656 3.113281-9.441406 5.503906-13.648438 1.785156-3.136718 1.25-7.070312-1.296875-9.617187l-10.734375-10.734375 12.6875-12.6875 10.734375 10.734375c2.546875 2.546875 6.496094 3.074219 9.617187 1.296875 4.207032-2.398438 8.800782-4.246094 13.648438-5.503906 3.527344-.902344 6-4.097656 6-7.742188v-10.097656h16v10.097656c0 3.644532 2.472656 6.832032 6 7.742188 4.847656 1.25 9.441406 3.105468 13.648438 5.503906 3.113281 1.777344 7.0625 1.25 9.617187-1.296875l10.734375-10.734375 12.6875 12.6875-10.734375 10.734375c-2.546875 2.546875-3.082031 6.488281-1.296875 9.617187 2.398438 4.207032 4.246094 8.800782 5.503906 13.648438.910156 3.527344 4.097656 6 7.742188 6h10.097656zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m360 80c-22.054688 0-40 17.945312-40 40s17.945312 40 40 40 40-17.945312 40-40-17.945312-40-40-40zm0 64c-13.230469 0-24-10.769531-24-24s10.769531-24 24-24 24 10.769531 24 24-10.769531 24-24 24zm0 0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m24 176h68.6875l29.65625 29.65625c1.527344 1.527344 3.578125 2.34375 5.65625 2.34375 1.03125 0 2.070312-.199219 3.0625-.609375 2.992188-1.238281 4.9375-4.160156 4.9375-7.390625v-24h32c13.230469 0 24-10.769531 24-24v-128c0-13.230469-10.769531-24-24-24h-144c-13.230469 0-24 10.769531-24 24v128c0 13.230469 10.769531 24 24 24zm-8-152c0-4.40625 3.585938-8 8-8h144c4.414062 0 8 3.59375 8 8v128c0 4.40625-3.585938 8-8 8h-40c-4.425781 0-8 3.585938-8 8v12.6875l-18.34375-18.34375c-1.496094-1.503906-3.527344-2.34375-5.65625-2.34375h-72c-4.414062 0-8-3.59375-8-8zm0 0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m32 32h128v16h-128zm0 0"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m48 64h96v16h-96zm0 0"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m32 96h128v16h-128zm0 0"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "m48 128h96v16h-96zm0 0"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m360 352h128v16h-128zm0 0"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "m328 352h16v16h-16zm0 0"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "m296 384h160v16h-160zm0 0"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m328 416h160v16h-160zm0 0"
});

var SvgVirtualAssistant = function SvgVirtualAssistant(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "496pt",
    viewBox: "0 0 496 496",
    width: "496pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVirtualAssistant, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/virtual-assistant.9440d219.svg";
export { ForwardRef as ReactComponent };